// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"964f0d43","952":"3bc72335"}[chunkId] + ".chunk.js";
};